import { render, staticRenderFns } from "./ReceiveInfoList.vue?vue&type=template&id=f9caeb52&scoped=true&"
import script from "./ReceiveInfoList.vue?vue&type=script&lang=js&"
export * from "./ReceiveInfoList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveInfoList.vue?vue&type=style&index=0&id=f9caeb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9caeb52",
  null
  
)

export default component.exports